import { FormModel } from 'common/form-state-manager/FormModel'
import { IsNotEmpty } from 'common/validation/decorators/IsNotEmpty'

export class ReferralProgramDescriptionFormModel extends FormModel {

    @IsNotEmpty()
    description: string

    constructor(initialData?: any) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
